export default "__VITE_ASSET__eec1a8cd__"